import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import authReducer from './auth/reducer';
import purchaseOrderReducer from './purchaseOrder/reducer';
import invoiceReducer from './invoice/reducer';

const createRootReducer = history => combineReducers({
  auth: authReducer,
  router: connectRouter(history),
  purchaseOrder: purchaseOrderReducer,
  invoice: invoiceReducer
});

export default createRootReducer;
